module.exports = __webpack_public_path__ + "static/media/default_thumbnail_1920_1080.c82f8cc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnail/default_thumbnail_1920_1080.jpg
// module id = 316
// module chunks = 2